import type { ResourceSyncStatus } from '../../../footballStatus'

/**
 * What a resync (or a factory reset) actually did, in one line.
 *
 * The readout used to list deleted row counts and nothing else — which is the readout for the very
 * bug that made this ticket necessary. `Resync football` deleted the standings, nothing re-fetched
 * them, `getStandings` quietly fell back to computing the table from our own fixtures, and the
 * readout cheerfully reported the rows it had deleted while the Premier League table did not move a
 * pixel. What was **re-fetched**, and what wasn't and why, is the half that answers "did that work".
 */
export function summariseSync(synced: ResourceSyncStatus[]): string {
  if (synced.length === 0) return 'nothing to re-fetch'
  return synced
    .map((entry) => (entry.ok ? `${entry.resource}: ok` : `${entry.resource}: ${entry.reason}`))
    .join(' · ')
}

export function summariseDeleted(deleted: Record<string, number>): string {
  const rows = Object.entries(deleted)
    .map(([table, count]) => `${table}: ${count}`)
    .join(', ')
  return rows || 'nothing'
}
